export default {
    "advanced": {
        "rangeSeparator": " / ",
        "dateRangePicker": {
            "separator": " / ",
            "from": "Vom",
            "to": "Bis"
        },
        "rangeInput": {
            "separator": "/"
        },
        "select": {
            "nItems": "{count} Elemente ausgewählt",
            "allItems": "Alle Elemenente ausgewählt",
            "noItems": "Keine Elemente ausgewählt"
        }
    }
};
